import api from "../axios";

const getAccountId = () => {
  return sessionStorage.getItem("acc_id");
};

const getUserAccountId = () => {
  return JSON.parse(localStorage.getItem("user"))?.account?.id;
};

// Fetch user profile
export async function getUserProfile() {
  const userAccountId = getUserAccountId();
  const response = await api.get(`/users/${userAccountId}/profile/`);
  return response.data;
}

// Update user profile
export async function updateUserProfile(data) {
  const userAccountId = getUserAccountId();
  const response = await api.put(`/users/${userAccountId}/profile/`, data);
  return response.data;
}

// SCRUM-992: default account / location / landing page. With a staffId these
// hit the admin endpoint for that staff member (staff_info.id, not the user
// id) in the currently selected account, which returns the preferences at the
// top level. Without one, the logged-in user's own defaults, which live on the
// profile endpoint under `default_preferences`. `optionsAccountId` asks for
// location_options of that account instead of the stored default account's.
const staffDefaultPreferencesUrl = (staffId) =>
  `/accounts/${getAccountId()}/staff/${staffId}/default-preferences/`;

export async function getDefaultPreferences(staffId, optionsAccountId) {
  const params = optionsAccountId ? { account_id: optionsAccountId } : {};
  if (staffId) {
    const response = await api.get(staffDefaultPreferencesUrl(staffId), { params });
    return response.data;
  }
  const response = await api.get(`/users/${getUserAccountId()}/profile/`, { params });
  // null (not undefined) until the backend adds default_preferences.
  return response.data?.default_preferences ?? null;
}

// Account and location are saved as a pair, so all three keys are always sent.
// On the profile endpoint a body with only default_* keys leaves the profile
// fields untouched.
export async function updateDefaultPreferences(staffId, data) {
  if (staffId) {
    const response = await api.put(staffDefaultPreferencesUrl(staffId), data);
    return response.data;
  }
  const response = await api.put(`/users/${getUserAccountId()}/profile/`, data);
  return response.data?.default_preferences ?? null;
}
